const AGENTS_API_URL =
  window.location.hostname === 'localhost'
    ? 'http://localhost:8010/api/v1'
    : `${window.location.origin}/agents-api/v1`;

export { AGENTS_API_URL };
